module.exports = __webpack_public_path__ + "static/media/UI.5b30eafc.js-p1";


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/UI.js-p1
// module id = 102
// module chunks = 0